import React, {useCallback} from "react";

export const useInputOnChangeValue = (fun?: (value: any) => void) => useCallback(({ target: { value }}: React.ChangeEvent<HTMLInputElement>) => {
  if (fun) fun(value);
}, [fun]);
